import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundComponent} from './not-found.component';

export const notFoundRoutes: Routes = [
    {
        path: '**',
        component: NotFoundComponent,
        data: {title: 'Страница не найдена'},
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(notFoundRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class NotFoundRoutingModule {}
